<header class="header">
  <section>
    <h3>{{ 'cityLocationSelectionDialogHeading' | translate }}</h3>
    @if (!isLocationPinned && !isMaps && !isWidget) {
    <span (click)="locationPinned()" class="pinned-location">
      <firebird-web-icon width="15px" height="15px" name="pinned-location">
      </firebird-web-icon>
      Pin Locations
    </span>
    }
  </section>

  <button
    mat-icon-button
    mat-dialog-close
    type="reset"
    aria-label="Close dialog"
  >
    <firebird-web-icon
      class="close-icon"
      name="cross"
      width="1.25rem"
      height="1.25rem"
    ></firebird-web-icon>
  </button>
</header>
<mat-divider></mat-divider>
<section class="content">
  <div class="location-selection">
    @if (!isCustomLocationSelected) {
    <firebird-web-menu-button
      class="continent-menu-btn"
      [disabled]="isLoading"
      [matMenuTriggerFor]="continentMenu"
      [text]="(selectedContinent$ | async)?.name || ''"
    ></firebird-web-menu-button>
    <firebird-web-menu-button
      class="region-menu-btn"
      [disabled]="isLoading"
      [matMenuTriggerFor]="regionMenu"
      [text]="(selectedRegion$ | async) || ''"
    ></firebird-web-menu-button>
    } @else {
    <firebird-web-menu-button
      class="continent-menu-btn"
      [disabled]="isLoading"
      [matMenuTriggerFor]="continentMenu"
      [text]="(selectedCustomLocationList$ | async)?.listName || ''"
    ></firebird-web-menu-button>
    }
  </div>
  <mat-divider></mat-divider>
  <div class="locations" [class.loading]="isLoading">
    @if (!isLoading) { @if (!isCustomLocationSelected) { @for (cityChunk of
    cityList; track cityChunk) {
    <ul>
      @for (city of cityChunk; track city) {
      <li
        role="button"
        tabindex="0"
        [class.active]="isCityActive(city)"
        (click)="onCitySelected(city)"
        (keydown.enter)="onCitySelected(city)"
        (keydown.space)="onCitySelected(city)"
      >
        {{ city.city }}
      </li>
      }
    </ul>
    } } @else { @for (customLocationChunk of customLocationList; track
    customLocationChunk) {
    <ul>
      @for (customLocation of customLocationChunk; track customLocation) {
      <li
        role="button"
        tabindex="0"
        [class.active]="isCustomLocationActive(customLocation)"
        (click)="onCustomLocationSelected(customLocation)"
        (keydown.enter)="onCustomLocationSelected(customLocation)"
        (keydown.space)="onCustomLocationSelected(customLocation)"
      >
        {{ customLocation.displayName }}
      </li>
      }
    </ul>
    } } } @else {
    <firebird-web-loader></firebird-web-loader>
    }
  </div>
</section>

<mat-menu class="locations-menu-panel" #continentMenu="matMenu">
  @for (customList of customLocationLists$ | async; track customList) {
  <button
    mat-menu-item
    [class.active]="(selectedCustomLocationList$ | async)?.id === customList.id"
    (click)="onCustomLocationChange(customList)"
    [attr.aria-label]="'Custom locations list' + customList.listName"
  >
    {{ customList.listName }}
  </button>
  }
  <mat-divider></mat-divider>
  @for (continent of continentList$ | async; track continent) {
  <button
    mat-menu-item
    [class.active]="
      (selectedCustomLocationList$ | async) === null &&
      (selectedContinent$ | async)?.id === continent.id
    "
    (click)="onContinentChange(continent)"
    [attr.aria-label]="continent.text + ' continent'"
  >
    <div
      [hasViewPermission]="[continent.id || '']"
      [alignRight]="true"
      key="PoolSet"
    >
      {{ continent.text }}
    </div>
  </button>
  }
</mat-menu>

<mat-menu #regionMenu="matMenu">
  @for (region of regionList$ | async; track region) {
  <button
    mat-menu-item
    [class.active]="(selectedRegion$ | async) === region.regionName"
    [attr.aria-label]="
      region.regionName +
      (region.regionName === allCitiesOptionKey ? '' : ' region')
    "
    (click)="onRegionChange(region.regionName)"
  >
    {{ region.regionName }}
  </button>
  }
</mat-menu>
